// @ts-check
import Axios from "axios";
import { Appsettings, ClientSetting } from "../Appsettings";
import StudyItem from "../models/studies/list";
import { SingJWT } from "./jwtTools";
/**
 *
 * @param {string} phone
 * @param {StudyItem} patient
 * @param {number} tiempo
 */
export async function shareWhatsapp(phone, patient, tiempo) {
  if (phone === "") {
    alert("número telefónico inválido");
    return;
  }
  const Token = SingJWT(
    {
      ID: patient?.id,
    },
    {
      expiresIn: `${tiempo}h`,
    },
  );
  try {
    let templateReq = await Axios.get(Appsettings.whatsappMessage, {
      headers: { "Cache-Control": "no-cache" },
    });

    let template = templateReq.data;
    const link = window.location.origin + "/externo/" + Token;
    template = template.replaceAll(
      "[[NOMBRE]]",
      patient?.getPatientName() || "",
    );
    template = template.replaceAll("[[LINK]]", link);
    template = template.replaceAll(
      "[[INSTITUCION]]",
      ClientSetting.InstitutionName,
    );

    const url = `https://wa.me/${phone}?text=${template}`;
    return url;
  } catch (error) {
    console.error("Error obteniendo el template", error);
  }
}

export default shareWhatsapp;
